import script from "./privacy-details.vue?vue&type=script&setup=true&lang=js"
export * from "./privacy-details.vue?vue&type=script&setup=true&lang=js"

import "./privacy-details.vue?vue&type=style&index=0&id=250f21db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-250f21db"]])

export default __exports__